import { render } from "./SpecialSkill.vue?vue&type=template&id=36e35f6e"
import script from "./SpecialSkill.vue?vue&type=script&lang=js"
export * from "./SpecialSkill.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__